import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CountUp from "react-countup";

const StatCounter = ({ value, index, className, sx }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const getNumericValue = (val) => parseFloat(val.replace(/[^0-9.]/g, ""));
  const numericValue = getNumericValue(value);

  return (
    <Typography
      variant="h2"
      className={className}
      sx={{
        fontSize: "48px",
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "Orbitron",
        userSelect: "none",
        ...sx,
      }}
    >
      <div>
        {mounted ? (
          <CountUp
            start={0}
            end={numericValue}
            duration={4}
            separator=","
            suffix={value.endsWith("+") ? "+" : value.replace(/[0-9.]/g, "")}
            useEasing
            enableScrollSpy
            scrollSpyOnce
          />
        ) : (
          numericValue.toLocaleString()
        )}
      </div>
    </Typography>
  );
};

export default StatCounter;
